export default __webpack_public_path__ + "static/media/sec3.19c24a4e.jpeg";